import { MouseEventHandler, useCallback, useRef } from 'react';
import { useToggle } from 'react-use';
import { MdAdd } from 'react-icons/md';
import { CSShiftCellDropdown } from '@lp/features/Scheduler/SchedulerClinicalSpecialists/components';
import { CSResource, CSShiftSelectPayload } from '@/api/apis/resources/schedule';

type CSShiftEmptyCellProps = {
  resource?: CSResource;
  usesDeductionRules?: boolean;
  onShiftChange: (shiftPayload?: CSShiftSelectPayload) => void;
};

export const CSShiftEmptyCell = ({ resource, usesDeductionRules, onShiftChange }: CSShiftEmptyCellProps) => {
  const elRef = useRef<HTMLButtonElement>(null);
  const [isOpen, toggleIsOpen] = useToggle(false);

  const onCellClick: MouseEventHandler<HTMLButtonElement> = useCallback(() => {
    toggleIsOpen();
  }, [toggleIsOpen]);

  return (
    <>
      <button
        ref={elRef}
        onClick={onCellClick}
        aria-label="add shift"
        className="flex items-center justify-center size-full rounded-lg text-base-20 border border-dashed border-base-20 opacity-0 focus:opacity-100 hover:opacity-100 transition cursor-pointer"
      >
        <MdAdd size={24} />
      </button>

      {isOpen && (
        <CSShiftCellDropdown
          triggerRef={elRef}
          isOpen={isOpen}
          allowedOrgans={resource?.organs}
          canPhoneSupport={resource?.canPhoneSupport}
          resourceTimeGroup={resource?.shiftTimeGroup}
          showTimeGroup={usesDeductionRules}
          onOpenChange={toggleIsOpen}
          onShiftChange={onShiftChange}
        />
      )}
    </>
  );
};
